// extracted by mini-css-extract-plugin
export default {"summary-wrapper":"Pg5DYH","summaryWrapper":"Pg5DYH","summary-line":"N1y0yk","summaryLine":"N1y0yk"};